import React from "react";
import Loadable from "react-loadable";
import { Switch, Route } from "react-router-dom";
import {NotFound} from "~/views/Errors";
import LoadingSpinner from "~/components/LoadingSpinner";

const ImportView = Loadable({
    loader: () => import("~/views/admin/import/ImportView"),
    loading: LoadingSpinner
});

export default ({ match }) => (
    <Switch>
        <Route path={`${match.url}/`} component={ImportView} />
        <Route component={NotFound} />
    </Switch>
);